import React from 'react'
import './loader.styles.scss'

const Loader = ({
    color
}) => {
    return (
        <div>
            <div className={`lds-grid ${color}`}>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    )
}

export default Loader